export default {
    computed: {
        validType() {
            return ['mcd', 'summit', 'live-course', 'sps'].indexOf(this.eventType) > -1;
        },

        validDocument() {
            return ['invoice', 'certificate'].indexOf(this.eventDocument) > -1;
        },

        eventType() {
            return this.$route.params.type;
        },

        eventDocument() {
            return this.$route.params.document;
        },

        eventName() {
            return {
                mcd: 'Masterclass Day',
                summit: 'Super Summit',
                'live-course': 'Live Course',
                sps: 'Suicide Prevetion Summit'
            }[this.eventType];
        },

        documentData() {
            const type = this.eventType === 'live-course' ? 'course' : 'event'

            return {
                invoice: {
                    heading: 'Retrieve Your Receipt',
                    helperText: `To generate your payment receipt, please select the relevant ${type} from the list below; enter your email address (this must be the same email you used to register); and click “Download Receipt”`,
                    component: 'gh-form-invoice'
                },
                certificate: {
                    heading: 'Generate Your Certificate of Attendance',
                    helperText: `To generate your attendance certificate, please select the relevant ${type} from the list below; enter your email address (this must be the same email you used to register); and click “Get Certificate”.`,
                    component: 'gh-form-certificate'
                }
            }[this.eventDocument];
        }
    }
}
